import {
    EndpointConfiguration as ForgeEndpointConfig,
    Stage as ForgeStage,
} from "@amzn/ads-forge-client";
import {
    EndpointConfiguration as AquilaEndpointConfig,
    Stage as AquilaStage,
} from "@amzn/aquila-service-type-script-client";

import type { AuthSettings } from "../store/auth";

export const authConfig: AuthSettings = {
    cognitoPoolId: "id",
    region: "us-east-1",
    apiEndpoint: "localhost:3100",
    ppApiEndpoint: "localhost:3100",
    discoveryApiEndpoint: "localhost:3100",
    adsApiEndpoint: "localhost:3100",
    g4sApiEndpoint: "localhost:3100",
    magnetoApiEndpoint: "localhost:3100",
    magnetoPoolId: "localhost:3100",
    aquilaConfig: {
        featureAccess: {
            configId: "test",
            awsAccountId: "test",
        },
        homePageFeedbackForm: {
            configId: "test",
            awsAccountId: "test",
        },
        insightDetailFeedbackForm: {
            configId: "test",
            awsAccountId: "test",
        },
        yourInsightsTabReportIssueConfig: {
            configId: "test",
            awsAccountId: "test",
        },
        allInsightsTabReportIssueConfig: {
            configId: "test",
            awsAccountId: "test",
        },
        sidePanelReportIssueConfig: {
            configId: "test",
            awsAccountId: "test",
        },
        createInsightDeckPageReportIssueConfig: {
            configId: "test",
            awsAccountId: "test",
        },
        generalThumbsFeedbackConfig: {
            configId: "test",
            awsAccountId: "test",
        },
        IHubFeatureRequestConfig: {
            configId: "test",
            awsAccountId: "test",
        },
    },
    g4sApiInvocationRoleArn: "",
    stage: "dev",
    aquilaApiEndpoint: new AquilaEndpointConfig(AquilaStage.BETA),
    forgeApiEndpoint: new ForgeEndpointConfig(ForgeStage.BETA),
    plmApiEndpoint: "localhost:3100",
    blinkApiEndpoint: "localhost:3100",
    blinkAwsAccountId: "123456789012",
    g4sServiceEndpoint: "localhost:3100",
    g4sServiceInvocationRoleArn: "",
    seleneApiEndpoint: "localhost:3100",
    rumAppId: "test-rum-app-id",
    rumRegion: "us-east-1",
    phoenixRumAppId: "test-phoenix-rum-app-id",
    phoenixCognitoPoolId: "test-cognito-pool-id",
};
